/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Desktop navigation (group 78, t6d-desktop-nav). This block is appended to assets/custom.js by manifests/78-desktop-nav.json;
 * this file is the same text, kept so that a test can read it. There are no words in it.
 *
 * 1. The logos of the Brands dropdown in the white bar carry data-src and data-srcset (snippet lc-desktop-nav): they are fetched on the
 *    first hover, focus or tap of that item, not with every page.
 * 2. Escape closes an open dropdown of the bar or an open header popover (account, language) and puts the focus back on the item or the
 *    button that opened it. The theme closes neither on Escape.
 * 3. An item of the bar that only opens its dropdown (its address ends in "#") does not jump to the top of the page or to the home page.
 * 4. A dropdown that would leave the window (the last item of the bar, in a long language or a narrow window) opens to the left, under the right
 *    end of its item, as the theme itself does for nested menus.
 * 5. Touch: a tap on an item that has a dropdown opens it and never leaves the page; the second tap closes it. The second tap on an item
 *    whose dropdown has no "All ..." row of its own (Repair Guides) still follows its link, as the theme does, so its page stays reachable.
 *    (Where the device has no hover the theme itself opens on the click; on a hybrid device it has opened on the mouseover before.)
 */
(function () {
  var BAR = '.nav-bar';
  var ITEM = '[data-type="menuitem"][aria-haspopup]';
  var muted = null;
  var tap = { item: null, type: '', open: false };

  function hasHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function panelOf(link) {
    var p = link.nextElementSibling;
    while (p && !p.hasAttribute('aria-hidden')) p = p.nextElementSibling;
    return p;
  }

  function closeItem(li) {
    var link = li.querySelector(ITEM);
    var panel = link && panelOf(link);
    if (!panel) return;
    link.setAttribute('aria-expanded', 'false');
    li.classList.remove('is-dropdown-open');
    panel.setAttribute('aria-hidden', 'true');
    if (li.parentNode && li.parentNode.classList) li.parentNode.classList.remove('nav-dropdown--glued');
  }

  // 4. a dropdown that would leave the window opens to the left
  function fit(li) {
    var link = li.querySelector(ITEM);
    var panel = link && panelOf(link);
    if (!panel || panel.getAttribute('aria-hidden') === 'false' || !panel.classList.contains('nav-dropdown')) return;
    panel.classList.remove('lc-dn--left');
    if (panel.getBoundingClientRect().right > document.documentElement.clientWidth) panel.classList.add('lc-dn--left');
  }

  // 1. the brand logos
  function loadLogos(li) {
    var imgs = li.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var set = img.getAttribute('data-srcset');
      if (set) img.setAttribute('srcset', set);
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }
  }
  ['mouseover', 'focusin', 'touchstart', 'click'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var li = e.target && e.target.closest ? e.target.closest(BAR + ' .nav-bar__item') : null;
      if (!li) return;
      fit(li);
      if (li.querySelector('img[data-src]')) loadLogos(li);
    }, { capture: true, passive: true });
  });

  // 2. Escape. The focus goes back to the trigger without the theme opening the dropdown again on that focus.
  document.addEventListener('focusin', function (e) {
    if (muted && e.target === muted) e.stopImmediatePropagation();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var active = document.activeElement;
    var back = null;
    var open = document.querySelectorAll(BAR + ' .is-dropdown-open');
    for (var i = 0; i < open.length; i++) {
      var link = open[i].querySelector(ITEM);
      if (link && (open[i].contains(active) || link === active)) back = link;
      closeItem(open[i]);
    }
    var pop = document.querySelector('.popover[aria-hidden="false"]');
    if (pop) {
      var trigger = pop.id ? document.querySelector('[aria-controls="' + pop.id + '"]') : null;
      if (trigger && (pop.contains(active) || trigger === active)) back = trigger;
      try { document.dispatchEvent(new CustomEvent('popover:close')); } catch (err) { /* the theme had no active popover */ }
    }
    if (back && back !== active) {
      muted = back;
      back.focus();
      muted = null;
    }
  });

  // 3 and 5. clicks and taps on the items of the bar
  document.addEventListener('pointerdown', function (e) {
    var link = e.target && e.target.closest ? e.target.closest(BAR + ' ' + ITEM) : null;
    tap = { item: link, type: e.pointerType, open: !!link && link.getAttribute('aria-expanded') === 'true' };
  }, true);
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest(BAR + ' ' + ITEM) : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var touch = !hasHover() || (tap.item === link && tap.type === 'touch');
    if (touch) {
      var wasOpen = tap.item === link ? tap.open : link.getAttribute('aria-expanded') === 'true';
      var panel = panelOf(link);
      var closes = /#$/.test(href) || (panel && panel.classList.contains('lc-dn--type'));
      if (!wasOpen) {
        e.preventDefault();
        return;
      }
      if (closes) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeItem(link.parentNode);
      }
      return;
    }
    if (/#$/.test(href)) e.preventDefault();
  }, true);
})();
